{
  "net": "Net",
  "gross": "Gross",
  "Mo": "Mo",
  "years": "Years",
  "first-payment-date": "First Payment Date",
  "last-payment-date": "Last Payment Date",
  "mortgage-commitment-date": "Mortgage Commitment Date",
  "late-penalty": "Late Penalty",
  "case-inst-mortgage": "Mortgage Ins. Case",
  "grace-period-days": "Grace period days",
  "interest-rate": "Interest rate",
  "interest": "Interest",
  "fixed": "Fixed",
  "variable": "Variable",
  "loan": "Loan",
  "heloc": "HELOC",
  "heloc_initial_draw": "Initial Draw",
  "construction_loan": "Construction Loan",
  "construction_loan_initial_loan": "Initial Loan",
  "mers": "MERS",
  "mers_min": "Min",
  "loan_type": "Loan Type",
  "margin": "Margin",
  "fee": "Fee",
  "period-start": "Period Start",
  "period-end": "Period end",
  "loans": "Loans",
  "delete-loan": "Delete Loan",
  "related-amounts": "Related Amounts",
  "amount-kind": "Amount Kind",
  "loan-amount": "Loan Amount",
  "purpose": "Purpose",
  "product": "Product",
  "buyer-issue-date": "Buyer CD Issue Date",
  "seller-issue-date": "Seller CD Issue Date",
  "days-passed": "Days Passed to be Charged with a Late Fee",
  "not-additional": "There are not additionals yet",
  "additional": "Additional",
  "add-additional": "Add Additional",
  "late-penalty-as": "Late Penalty As",
  "not-interests": "There are not interests added yet",
  "add-interests": "Add interests",
  "days_per_year": "Days per year",
  "conventionalInsured": "Conventional Insured",
  "conventionalUninsured": "Conventional Uninsured",
  "rhs": "RHS",
  "fha": "FHA",
  "va": "VA",
  "purchase": "Purchase",
  "refinance": "Refinance",
  "homeEqualityLoan": "Home Equality Loan",
  "construction": "Construction",
  "deleteInterestTitle": "Delete Interest",
  "deleteInterestConfirmation": "Are you sure you want to delete the interest?",
  "deleteAdditionalTitle": "Delete Additional",
  "deleteAdditionalConfirmation": "Are you sure you want to delete the additional?",
  "deleteLoanConfirmation": "Are you sure you want to delete the loan?",
  "increases": "Increases",
  "disclosures": "Disclosures",
  "noLoansYet": "This order does not have any loans yet",
  "escrowAmounts": "Escrow Amounts",
  "lendingTo": "lending to",
  "createLoanInterest": "Create Loan Interest",
  "createLoan": "Add Loan",
  "loan-unknown": "Loan #(unknown)",
  "loan-created": "Loan successfully created",
  "lenders": "Lenders",
  "add-lender": "Add lender",
  "add-lender-title": "Add a lender to this order",
  "add-lender-text": "Search for a contact and add them as a lender.",
  "no-lenders-alert": "This order has no lenders yet. Add one to complete the loan details.",
  "remove-lender": "Remove lender",
  "lender-already-added": "This contact is already a lender on this order."
}
